import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function DefaultedLoanReport() {
  return <ReportForm reportAPI={ ReportAPI.DEFAULTED_LOAN_DETAILS } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/DefaultedLoanReport.js